import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Styles
import styles from './home.scss';

const Home = ({ usdata, international }) => (
  <div>
    <h3 className={styles.home}>Welcome to PRB Datafinder</h3>
    <hr />
    <ul>
      {usdata.map(({ shortTitle, dataView, slug }) => (
        <li key={slug}>
          <Link to={`/${dataView}/indicator/${slug}`}>{shortTitle}</Link>
        </li>
      ))}
    </ul>
    <ul>
      {international.map(({ shortTitle, dataView, slug }) => (
        <li key={slug}>
          <Link to={`/${dataView}/indicator/${slug}`}>{shortTitle}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const indicatorPropType = {
  slug: PropTypes.string.isRequired,
  shortTitle: PropTypes.string.isRequired,
  dataView: PropTypes.string.isRequired,
};

Home.propTypes = {
  usdata: PropTypes.arrayOf(PropTypes.shape(indicatorPropType)).isRequired,
  international:
    PropTypes.arrayOf(PropTypes.shape(indicatorPropType)).isRequired,
};

// @TODO make these into selectors
const mapStateToProps = ({
  data: {
    allIndicators: {
      usdata = { byId: {}, all: [] },
      international = { byId: {}, all: [] },
    } = {},
  } = {},
}) => ({
  usdata: usdata.all.map((x) => {
    const { slug, shortTitle, dataView } = usdata.byId[x];
    return { slug, shortTitle, dataView };
  }),
  international: international.all.map((x) => {
    const { slug, shortTitle, dataView } = international.byId[x];
    return { slug, shortTitle, dataView };
  }),
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./app/components/home/index.js